const { uniq } = require('lodash');
const { contractConstant } = require('./contract');

const DieselPegConstants = {
  headerMapping: {
    Source: 'source',
    'Source Type': 'source_type',
    'City Reference': 'city_ref',
    'Transporter Reference ID': 'transporter_ref_id',
    'Base Fuel Rate': 'bdr_amount',
    'Min BFR Threshold': 'min_bdr_threshold',
    'Max BFR Factor': 'max_bdr_factor',
    'Rate Factor': 'diesel_component_factor',
    'Updated Base Fuel Rate': 'update_bdr_amount',
    Category: 'category',
    'Additional Factor': 'additional_factor',
    'Fuel Type': 'fuel_type',
  },
  mandatoryHeaders: {
    'Source*': 'source',
    'Source Type*': 'source_type',
    'City Reference*': 'city_ref',
    'Transporter Reference ID*': 'transporter_ref_id',
    'Base Fuel Rate*': 'bdr_amount',
  },
  nonMandatoryHeaders: {
    'Min BFR Threshold': 'min_bdr_threshold',
    'Max BFR Factor': 'max_bdr_factor',
    'Rate Factor': 'diesel_component_factor',
    'Updated Base Fuel Rate': 'update_bdr_amount',
    Category: 'category',
    'Additional Factor': 'additional_factor',
    'Fuel Type': 'fuel_type',
  },
  onlyForExportHeaders: {
    'Fuel Change(%)': 'fuel_change_percentage',
    'Freight Change(%)': 'freight_change_percentage',
  },
  TransporterBatchSize: 500,
  ContractsBatchSize: 500,
  BDRBatchSize: 500,

  FrequencyTypes: {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
  },

  DieselPegContractTypes: {
    FTL: 'FTL',
    PTL: 'PTL',
    BOTH: 'Both',
  },

  DieselPegMethods: {
    FIXED: 'fixed',
    FACTOR: 'factor',
  },

  DieselPegUserRole: 'super_admin',
  QuarterMonths: [3, 6, 9, 12],

  SourceTypes: uniq(Object.values(contractConstant.SOURCE_TYPE)),

  AverageCityReference: 'average',
  ManualCityReference: 'manual',
};

module.exports = { DieselPegConstants };
